import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconTransfer = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10.176 3.263a1 1 0 0 1 .061 1.413L6.273 9H20a1 1 0 1 1 0 2H4a1 1 0 0 1-.737-1.676l5.5-6a1 1 0 0 1 1.413-.061M3 14a1 1 0 0 1 1-1h16a1 1 0 0 1 .737 1.676l-5.5 6a1 1 0 1 1-1.474-1.352L17.727 15H4a1 1 0 0 1-1-1"
            clipRule="evenodd"
        />
    </svg>
);
